<div class="p-4 md:p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 md:mb-6 gap-2">
    <h3 class="font-bold text-lg md:text-xl self-start md:self-center">{{ '::OrderDetail' | abpLocalization }}</h3>
    <div class="flex flex-col sm:flex-row sm:items-center gap-2 mb-2 sm:mb-0 w-full sm:w-auto">
      <app-metro-button [text]="'::Back' | abpLocalization" variant="secondary" size="sm" (clicked)="goBack()"
        class="sm:mb-0 w-full sm:w-auto">
      </app-metro-button>

      <!-- Confirm Payment Button -->
      <!-- winepassport#389 — en mobile la acción principal va primero (antes de "Volver") y en
           tamaño normal; desde sm vuelve al orden y tamaño de siempre. -->
      @if (showConfirmPaymentButton()) {
      <app-metro-button [text]="'::ConfirmPayment' | abpLocalization" variant="primary" size="md"
        [disabled]="isConfirmingPayment" (clicked)="confirmPayment()" class="w-full order-first sm:hidden">
      </app-metro-button>
      <app-metro-button [text]="'::ConfirmPayment' | abpLocalization" variant="primary" size="sm"
        [disabled]="isConfirmingPayment" (clicked)="confirmPayment()" class="hidden sm:block sm:w-auto">
      </app-metro-button>
      }

      <!-- Deliver Button -->
      @if (showDeliverButton()) {
      <app-metro-button [text]="'::Deliver' | abpLocalization" variant="primary" size="md" (clicked)="deliverOrder()"
        class="w-full order-first sm:hidden">
      </app-metro-button>
      <app-metro-button [text]="'::Deliver' | abpLocalization" variant="primary" size="sm" (clicked)="deliverOrder()"
        class="hidden sm:block sm:w-auto">
      </app-metro-button>
      }
    </div>
  </div>

  @if (order) {
  <!-- Basic Order Info Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <div class="bg-white p-4 rounded-lg shadow">
      <p class="text-sm text-gray-500">{{ '::OrderID' | abpLocalization }}</p>
      <p class="font-semibold">#{{ order.id }}</p>
    </div>
    <div class="bg-white p-4 rounded-lg shadow">
      <p class="text-sm text-gray-500">{{ '::Date' | abpLocalization }}</p>
      <p class="font-semibold">{{ order.creationTime | date:'short' }}</p>
    </div>
    <div class="bg-white p-4 rounded-lg shadow">
      <p class="text-sm text-gray-500 font-sans">{{ '::Status' | abpLocalization }}</p>
      <p class="font-semibold font-sans" [class]="getStatusClass(order.orderStatus)">{{ getStatusText(order.orderStatus)
        | abpLocalization }}</p>
    </div>
    <div class="bg-white p-4 rounded-lg shadow">
      <p class="text-sm text-gray-500">{{ '::Total' | abpLocalization }}</p>
      <p class="font-semibold">${{ order.total }}</p>
    </div>
  </div>

  <!-- Customer and Order Info -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
    <!-- Customer Info -->
    <div class="bg-white rounded-lg shadow p-4 md:p-6">
      <h4 class="font-semibold text-base md:text-lg mb-3">{{ '::CustomerInfo' | abpLocalization }}</h4>
      <div class="space-y-2">
        <p><span class="font-medium">{{ '::Customer' | abpLocalization }}:</span> {{ order.customerName }}</p>
        <p><span class="font-medium">{{ '::Email' | abpLocalization }}:</span> {{ order.customerEmail }}</p>
        <p><span class="font-medium">{{ '::Phone' | abpLocalization }}:</span> {{ order.customerPhone }}</p>
        <p><span class="font-medium">{{ '::DNI' | abpLocalization }}:</span> {{ order.customerDni }}</p>
        <p><span class="font-medium">{{ '::Address' | abpLocalization }}:</span> {{ formatCustomerAddress(order) || '-' }}</p>
      </div>
    </div>

    <!-- Payment and Sommelier Info -->
    <div class="bg-white rounded-lg shadow p-4 md:p-6">
      <div class="mb-3">
        <h4 class="font-semibold text-base md:text-lg">{{ '::SommelierInfo' | abpLocalization }}</h4>
        <p><span class="font-medium">{{ '::Sommelier' | abpLocalization }}:</span> {{ order.sommelierName }}</p>
        <p><span class="font-medium">{{ '::User' | abpLocalization }}:</span> {{ order.userName }}</p>
      </div>

      <div class="mt-3">
        <h4 class="font-semibold text-base md:text-lg">{{ '::PaymentInfo' | abpLocalization }}</h4>
        <p><span class="font-medium">{{ '::PaymentMethod' | abpLocalization }}:</span> {{
          getPaymentMethodText(order.paymentMethod) }}</p>
        <p><span class="font-medium">{{ '::TransactionId' | abpLocalization }}:</span> {{ order.paymentTransactionId ||
          'N/A' }}</p>
      </div>
    </div>
  </div>

  <!-- Shipping Address and Notes -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
    <div class="bg-white rounded-lg shadow p-4 md:p-6">
      @if (order.pickupAddress) {
        <h4 class="font-semibold text-base md:text-lg mb-3">{{ '::PickupAddress' | abpLocalization }}</h4>
        <div>
          <p>{{ order.pickupAddress }}</p>
        </div>
      } @else {
        <h4 class="font-semibold text-base md:text-lg mb-3">{{ '::ShippingAddress' | abpLocalization }}</h4>
        <div>
          <p>{{ order.shippingAddressLine }}</p>
          <p>{{ order.city }}, {{ order.state }} {{ order.postalCode }}</p>
          <p>{{ order.country }}</p>
        </div>
      }
    </div>

    <div class="bg-white rounded-lg shadow p-4 md:p-6">
      <h4 class="font-semibold text-base md:text-lg mb-3">{{ '::Notes' | abpLocalization }}</h4>
      <p>{{ order.notes || 'No notes' }}</p>
    </div>
  </div>

  <!-- Order Items -->
  <div class="bg-white rounded-lg shadow p-4 md:p-6 mb-6">
    <div class="flex items-center justify-between mb-4">
      <h4 class="font-semibold text-base md:text-lg">{{ '::OrderItems' | abpLocalization }} ({{ order.itemCount }})</h4>
      @if (order.priceListName) {
      <span class="text-sm text-gray-500"><span class="font-medium">{{ '::PriceList' | abpLocalization }}:</span> {{ order.priceListName }}</span>
      }
    </div>
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider text-sm">{{ '::Wine' |
              abpLocalization }}</th>
            <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider text-sm">{{ '::Quantity' |
              abpLocalization }}</th>
            <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider text-sm">{{ '::UnitPrice'
              | abpLocalization }}</th>
            <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider text-sm">{{ '::Total' |
              abpLocalization }}</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          @for (item of order.orderItems; track $index) {
          <tr class="hover:bg-gray-50">
            <td class="px-3 py-2 whitespace-nowrap text-sm">
              <div class="font-medium text-gray-900">{{ item.wineName }}</div>
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
              <div>{{ item.quantity }}</div>
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
              ${{ item.unitPrice }}
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
              ${{ item.totalPrice }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Order Summary -->
  <div class="bg-white rounded-lg shadow p-4 md:p-6">
    <h4 class="font-semibold text-base md:text-lg mb-4">{{ '::OrderSummary' | abpLocalization }}</h4>
    <div class="grid grid-cols-2 gap-4">
      <div class="text-right">
        <p class="text-sm text-gray-500 font-sans">{{ '::SubTotal' | abpLocalization }}</p>
        <p class="text-sm text-gray-500 font-sans">{{ '::Tax' | abpLocalization }}</p>
        @if (order.couponCode) {
        <p class="text-sm text-red-500 font-sans">{{ '::Discount' | abpLocalization }} ({{ order.couponCode }})</p>
        }
        @if (order.interestCharge > 0) {
        <p class="text-sm text-gray-500 font-sans">{{ '::InterestCharge' | abpLocalization }}</p>
        }
        <p class="text-sm font-bold mt-2 font-sans">{{ '::Total' | abpLocalization }}</p>
      </div>
      <div class="text-right">
        <p class="text-sm text-gray-900 font-sans">${{ order.subTotal | number:'1.2-2' }}</p>
        <p class="text-sm text-gray-900 font-sans">${{ order.tax | number:'1.2-2' }}</p>
        @if (order.couponCode) {
        <p class="text-sm text-red-500 font-sans">-${{ order.couponDiscountAmount | number:'1.2-2' }}</p>
        }
        @if (order.interestCharge > 0) {
        <p class="text-sm text-gray-900 font-sans">${{ order.interestCharge | number:'1.2-2' }}</p>
        }
        <p class="text-sm font-bold text-gray-900 mt-2 font-sans">${{ order.total }}</p>
      </div>
    </div>
  </div>

  <!-- Cancel Order Button -->
  @if (showCancelOrderButton()) {
  <div class="flex justify-start mt-4">
    <app-metro-button [text]="'::CancelOrder' | abpLocalization" variant="danger" size="sm"
      [disabled]="!isCancelOrderEnabled()" (clicked)="cancelOrder()" class="w-auto">
    </app-metro-button>
  </div>
  }
  } @else {
  <div class="bg-white rounded-lg shadow p-6 text-center">
    <p class="text-gray-500">{{ '::Loading' | abpLocalization }}...</p>
  </div>
  }
</div>